import "./style.css";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";
import { ReactComponent as ScrollArrow } from "assets/scroll-arrow.svg";

const ProjectCard = ({
  image = null,
  color = "bg-stone-900",
  name = "",
  date = "",
  onClick = () => {},
}) => {
  const { ref, inView } = useInView({ threshold: 0.35 });
  const animation = useAnimation();
  const childAnimation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        scale: 1,
        transition: { duration: 1, bounce: 0.3, type: "spring" },
      });
      childAnimation.start({
        width: "0%",
        transition: {
          duration: 1.25,
          bounce: 0.3,
          type: "spring",
          delay: 0.3,
        },
      });
    } else {
      animation.start({
        scale: 0.5,
        transition: { duration: 1, bounce: 0.3, type: "spring" },
      });
      childAnimation.start({
        width: "100%",
        transition: {
          duration: 1.25,
          bounce: 0.3,
          type: "spring",
          delay: 0.3,
        },
      });
    }
  }, [inView, animation, childAnimation]);
  const [cardHover, setCardHover] = useState(false);

  return (
    <motion.div
      animate={animation}
      ref={ref}
      className='relative basis-1/2 project-card group scale-50'
      onMouseOver={(e) => {
        setCardHover(true);
      }}
      onMouseOut={(e) => {
        setCardHover(false);
      }}
    >
      <div className='bg-transparent group-hover:bg-black/[.2] w-[100%] h-[100%] absolute top-0 left-0 z-[4]'></div>
      <img
        src={image}
        alt='project'
        className='w-[100%] aspect-video object-cover'
      />
      <div className='absolute left-[3em] bottom-[20%] z-[6] flex max-h-[28px] md:max-h-[36px] lg:max-h-[50px] overflow-hidden'>
        {name.split("").map((letter) => {
          if (letter === " ") {
            return (
              <motion.p
                initial={{ rotate: 90, y: "100%" }}
                animate={
                  cardHover ? { rotate: 0, y: 0 } : { rotate: 90, y: "100%" }
                }
                transition={{
                  type: "spring",
                  bounce: 0.3,
                  duration: 0.75,
                  delay: 0.125,
                }}
                className='text-xl md:text-3xl lg:text-5xl text-light font-semibold'
              >
                &nbsp;
              </motion.p>
            );
          }
          return (
            <motion.p
              initial={{ rotate: 90, y: "100%" }}
              animate={
                cardHover ? { rotate: 0, y: 0 } : { rotate: 90, y: "100%" }
              }
              transition={{
                type: "spring",
                bounce: 0.3,
                duration: 0.75,
                delay: 0.125,
              }}
              className='text-xl md:text-3xl lg:text-5xl text-light font-semibold'
            >
              {letter}
            </motion.p>
          );
        })}
      </div>

      <div className='absolute left-[3em] bottom-[10%] z-[6] flex max-h-[28px] overflow-hidden'>
        {date.split("").map((letter) => {
          return (
            <motion.p
              initial={{ scale: 0 }}
              animate={cardHover ? { scale: 1 } : { scale: 0 }}
              transition={{
                type: "spring",
                bounce: 0.3,
                duration: 0.75,
                delay: 0.125,
              }}
              className='lg:text-xl text-light'
            >
              {letter}
            </motion.p>
          );
        })}
      </div>
      <div className='absolute right-0 bottom-[10%] translate-x-1/4 z-[6] flex'>
        <motion.button
          initial={{ scale: 0 }}
          animate={cardHover ? { scale: 1 } : { sclae: 0 }}
          transition={{
            type: "spring",
            bounce: 0.3,
            duration: 0.75,
            delay: 0.125,
          }}
          className='bg-light1 p-6 rounded-full'
          onClick={onClick}
        >
          <motion.div
            initial={{ rotate: 180 }}
            animate={cardHover ? { rotate: 585 } : { rotate: 180 }}
            transition={{
              type: "spring",
              bounce: 0.3,
              duration: 0.75,
              delay: 0.125,
            }}
          >
            <ScrollArrow className='fill-dark1 w-[60px] h-[60px]' />
          </motion.div>
        </motion.button>
      </div>

      <motion.div
        animate={childAnimation}
        className={`absolute top-0 left-0 w-[100%] h-[100%] z-[5] bg-stone-600 ${
          cardHover ? color : ``
        } `}
      ></motion.div>
    </motion.div>
  );
};

export default ProjectCard;
